export const minTipAmount = 1
export const maxTipAmount = 9

export const minTipMessageLength = 1
export const maxTipMessageLength = 256
